import { Box, Modal, Typography } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'

import useStyle from './useStyles'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 650,
  height: 450,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function ProcessDetails ({ open, setOpen, process }) {
  const classes = useStyle()
  const handleClose = () => setOpen(false)

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className={classes.boxbuttonClose}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={handleClose}
            />
          </div>

          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            variant="h6"
            component="h2"
          >
            Detalles del proceso de habilitación
          </Typography>
          {process && (
            <>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#3e455f'
                  }}
                >
                  Organizaciones procesadas:
                </Typography>
                <Typography
                  style={{
                    paddingLeft: 2,
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#252e54'
                  }}
                >
                  {process.totalProcessedOrgCount}
                </Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#3e455f'
                  }}
                >
                  Organizaciones procesadas con éxito:
                </Typography>
                <Typography
                  style={{
                    paddingLeft: 2,
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#252e54'
                  }}
                >
                  {process.successfullyProcessedCount}
                </Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#3e455f'
                  }}
                >
                  Organizaciones procesadas con errores:
                </Typography>
                <Typography
                  style={{
                    paddingLeft: 2,
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#252e54'
                  }}
                >
                  {process.whithErrorProcessedCount}
                </Typography>
              </div>

              <Typography className={classes.typography}>
                Listado de errores:
              </Typography>

              <div
                style={{
                  width: '100%',
                  marginTop: 10,
                  height: 250,
                  overflowY: 'auto'
                }}
              >
                {process &&
                  process.failures.length > 0 &&
                  process.failures.map((failure, index) => (
                    <div
                      key={index}
                      style={{
                        width: '100%',
                        display: 'flex',
                        color: '#737373'
                      }}
                    >
                      <div
                        style={{
                          width: '20%',
                          display: 'flex'
                        }}
                      >
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.75rem',
                            color: '#3e455f'
                          }}
                        >
                          CUIT:
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.75rem',
                            paddingLeft: 2
                          }}
                        >
                          {failure.CUIT}
                        </Typography>
                      </div>
                      <div
                        style={{
                          width: '80%',
                          display: 'flex'
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            color: '#3e455f'
                          }}
                        >
                          Detalle:
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            paddingLeft: 3
                          }}
                        >
                          {failure.failure}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            paddingLeft: 3
                          }}
                        >
                          {failure.value}
                        </Typography>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
          <Box className={classes.buttons}>
            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyle()
  return (
    <Box className={classes.confirmButton}>
      <Typography
        onClick={() => {
          handleClose()
        }}
        className={classes.confirmButtonTypography}
      >
        Cerrar
      </Typography>
    </Box>
  )
}
